import React, { forwardRef, useImperativeHandle, useState } from "react";
import Box from "@mui/material/Box";
import ETextField from "../_elements/form-elements/etextfield";
import EDropdown from "../_elements/form-elements/edropdown";
import { Checkbox, Typography } from "@mui/material";
import ChipsInput from "../_elements/form-elements/chips-input";

import { FormattedMessage } from "react-intl";

const EformBuilder = forwardRef((props, ref) => {
  const { formElements, onFormDataChange } = props;
  const [formData, setFormData] = useState(
    formElements.map((el) => {
      return { ...el };
    })
  );
  const [formDirty, setFormDirty] = useState(false);

  const handleValueChange = (value, elementName) => {
    const elementIndex = formData.findIndex((el) => el.name === elementName);
    // copy form array
    const newForm = formData.slice();
    newForm[elementIndex]["value"] = value;
    // console.log('bahi value change', newForm);
    setFormData(newForm);
  };

  useImperativeHandle(ref, () => ({
    getFormData: formData,
    validate: () => {
      setFormDirty(true);
      for (let i = 0; i < formData.length; i++) {
        const el = formData[i];
        if (
          el.required &&
          (el.value === "" ||
            (el.type === "number" && isNaN(el.value)) ||
            el.value === false)
        ) {
          return false;
        }
      }

      return true;
    },
    getElementValue: (name) => {
      const field = formData.find((el) => el.name === name);

      return field.value;
    }
  }));

  React.useEffect(() => {
    setFormData(formElements);
  }, [formElements]);

  React.useEffect(() => {
    if (onFormDataChange) {
      onFormDataChange();
    }
  }, [formData]);

  return (
    <Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(12, 1fr)",
          gridGap: "24px"
        }}
      >
        {formData.map((el, index) => {
          return (
            <Box className={el.size} key={el.name + "-" + index}>
              {el.type !== "dropdown" && el.type !== "checkbox" && (
                <ETextField
                  label={el.label}
                  // label={messages[lang][el.label]}
                  name={el.name}
                  type={el.type}
                  initValue={el.value}
                  setValue={handleValueChange}
                  error={!el.value && formDirty}
                  required={el.required}
                  disabled={el.disabled || false}
                  tooltip={el.tooltip}
                  tooltipMessage={el.tooltipMessage}
                  inputProps={{
                    "data-testid": el.dataTestId
                  }}
                />
              )}

              {el.type === "dropdown" && (
                <EDropdown
                  label={el.label}
                  name={el.name}
                  type={el.type}
                  initValue={el.value}
                  setValue={handleValueChange}
                  error={!el.value && formDirty}
                  required={el.required}
                  disabled={el.disabled || false}
                  options={el.options || []}
                  placeholder={el.placeholder || ""}
                  inputProps={{
                    "data-testid": el.dataTestId
                  }}
                />
              )}

              {el.type === "checkbox" && (
                <label
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    marginTop: "1rem"
                  }}
                >
                  <Checkbox
                    name={el.name}
                    size="small"
                    checked={el.value === "true" ? true : false}
                    onClick={(e) => {
                      handleValueChange(e.target.checked + "", el.name);
                    }}
                  />
                  <Typography
                    variant="subtitle2"
                    component="span"
                    fontWeight={400}
                    marginTop={"9px"}
                  >
                    <FormattedMessage id={el.label} />
                  </Typography>
                </label>
              )}
              {el.type === "chipsInput" && (
                <ChipsInput
                  label={el.label}
                  name={el.name}
                  type={el.type}
                  initValue={el.value}
                  setValue={handleValueChange}
                  error={!el.value && formDirty}
                  required={el.required}
                  disabled={el.disabled || false}
                  tooltip={el.tooltip}
                  tooltipMessage={el.tooltipMessage}
                />
              )}
            </Box>
          );
        })}
      </Box>

      {/* <Button>Save</Button> */}
    </Box>
  );
});

export default EformBuilder;
